/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */
export const unexpectedError = "unexpected_error";
export const postRequestFailed = "post_request_failed";
